export const PokemonSeries: {[seriesId: number]: string} = {
    1: 'BWシリーズ',
    2: 'XYシリーズ',
    3: 'サン&ムーンシリーズ',
    4: 'ソード&シールドシリーズ',
    5: 'スカーレット&バイオレットシリーズ',
    39: 'LEGENDシリーズ',
    40: 'Classicシリーズ',
    72: 'MEGAシリーズ',
    73: 'DPtシリーズ',
    74: 'DPシリーズ',
    75: 'PCGシリーズ',
    76: 'ADVシリーズ',
    77: 'eシリーズ',
    78: '★neoシリーズ',
    79: 'PMCGシリーズ',
} as const
